import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trackingData: null,
  status: 'idle',
  error: null,
};

const trackingDataSlice = createSlice({
  name: 'trackingData',
  initialState,
  reducers: {
    setTrackingData: (state, action) => {
      state.trackingData = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setTrackingData, setError, setLoading } =
  trackingDataSlice.actions;
export default trackingDataSlice.reducer;
